import instance from '@/services/repository';

const resource = '/projectstatusses';

export default {
    get() {
        return instance.get(`${resource}`);
    },
    create(payload: IProjectStatus) {
        return instance.post(`${resource}`, payload);
    },
    update(payload: IProjectStatus) {
        return instance.put(`${resource}/${payload.id}`, payload);
    },
    updateOrderList(payload: IProjectStatus[]) {
        return instance.put(`${resource}`, payload);
    },
    delete(oldValue: number, newValue: number) {
        return instance.delete(`${resource}/${oldValue}?newValue=${newValue}`);
    },
};
